var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBook = function SvgIconBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.667v18.667c0 2.934 2.392 4 4 4h20v-2.667H8.016c-.616-.016-1.35-.259-1.35-1.333 0-1.075.734-1.318 1.35-1.334H28V5.334a2.67 2.67 0 0 0-2.667-2.667H8c-1.608 0-4 1.065-4 4Z",
    fill: "#fff"
  })));
};
export default SvgIconBook;